import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-row flex-wrap gap-x-12 gap-y-3 text-sm mt-3"
}
const _hoisted_2 = ["data-dusk"]
const _hoisted_3 = { class: "font-semibold text-sm text-gray-900" }
const _hoisted_4 = {
  key: 0,
  "data-dusk": "cart-item-option",
  class: "flex flex-col"
}
const _hoisted_5 = {
  class: "font-semibold text-xs text-gray-500",
  "data-dusk": "cart-item-option-pack"
}
const _hoisted_6 = { class: "font-semibold text-sm text-gray-900" }
const _hoisted_7 = {
  key: 0,
  class: "mt-6"
}
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = { class: "mr-4 -ml-4 flex items-center" }
const _hoisted_10 = { class: "flex-1" }
const _hoisted_11 = {
  key: 1,
  class: "mt-6",
  "data-dusk": "stock-item-info"
}
const _hoisted_12 = { class: "flex items-stretch gap-4" }

import { useOrderCard } from '@/composables/use-order-card';
import { formatPower } from '@/lib/helpers/format-power';
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { OrderItem } from '@/models/webshop.model';
import { PowerSelection } from '@/lib/components/PowerSelection';
import BaseCheckbox from '@/lib/components/Checkbox/BaseCheckbox.vue';
import BaseOrderCard from './BaseOrderCard.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderCardMultiPower',
  props: {
    item: {},
    isLoading: { type: Boolean },
    category: {},
    editable: { type: Boolean },
    isSelected: { type: Boolean },
    dataDusk: {}
  },
  emits: ['remove-item', 'update-item', 'select-item'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const { t } = useI18n();
const baseCardRef = ref<InstanceType<typeof BaseOrderCard> | null>(null);

const {
  isSelected,
  displayOptions,
  parsedPowerQuantities,
  handleSelectionChange,
  handlePowerQuantitiesUpdate,
  getFallbackImage
} = useOrderCard(props, emit);


watch(() => props.isLoading, (newVal) => {
  if (baseCardRef.value && !newVal && baseCardRef.value.isLoadingLocal) {
    baseCardRef.value.resetRemovingState();
  }
});

const isPowerMode = ref(true);
const getSelectedPowerOptions = () => {
  const validOptions = parsedPowerQuantities.value
    .filter((option) => option.quantity > 0)
    .map((option) => ({
      label: `${option.power}`,
      value: option.power,
      quantity: option.quantity
    }));

  return [...validOptions].sort((a, b) => parseFloat(a.value) - parseFloat(b.value));
};

const getAllPowerOptions = () => {
  const powerProperty = props.item.productOptions?.powers;
  let allPowers: string[] = [];

  if (powerProperty) {
    if (powerProperty.options && Object.keys(powerProperty.options).length > 0) {
      if (Array.isArray(powerProperty.options)) {
        allPowers = [...powerProperty.options].map((power) => power.trim());
      } else {
        allPowers = Object.keys(powerProperty.options).map((power) => power.trim());
      }
    } else if ('stepMax' in powerProperty && 'stepMin' in powerProperty && 'stepValue' in powerProperty) {
      const step = powerProperty.stepValue as number;
      const min = powerProperty.stepMin as number;
      const max = powerProperty.stepMax as number;

      for (let i = min; i <= max; i += step) {
        allPowers.push(i.toFixed(2));
      }
    }
  }

  if (allPowers.length === 0) {
    allPowers = parsedPowerQuantities.value.map((pq) => pq.power);
  }

  const existingPowerMap = new Map(
    parsedPowerQuantities.value.map((pq) => [formatPower(pq.power).trim(), pq.quantity])
  );

  const allOptions = allPowers.map((raw) => {
    const formatted = formatPower(raw);
    return {
      label: formatted,
      value: formatted,
      quantity: existingPowerMap.get(formatted) || 0
    };
  });

  return [...allOptions].sort((a, b) => parseFloat(a.value) - parseFloat(b.value));
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseOrderCard, {
    ref_key: "baseCardRef",
    ref: baseCardRef,
    item: _ctx.item,
    category: _ctx.category,
    editable: _ctx.editable,
    "is-loading": _ctx.isLoading,
    "data-dusk": _ctx.dataDusk,
    "fallback-image": _unref(getFallbackImage)(_ctx.category),
    onUpdateItem: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update-item', $event))),
    onSelectItem: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('select-item', $event))),
    onRemoveItem: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('remove-item', $event)))
  }, {
    "display-options": _withCtx(() => [
      (_unref(displayOptions).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayOptions), (option) => {
              return (_openBlock(), _createElementBlock("div", {
                key: option.key,
                "data-dusk": "cart-item-option",
                class: "flex flex-col"
              }, [
                _createElementVNode("div", {
                  class: "font-semibold text-xs text-gray-500",
                  "data-dusk": `cart-item-option-${option.key}`
                }, _toDisplayString(option.label), 9, _hoisted_2),
                _createElementVNode("div", _hoisted_3, _toDisplayString(option.value), 1)
              ]))
            }), 128)),
            (_ctx.item?.variantOptionLabel)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('platform.webshop.pack')), 1),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.item?.variantOptionLabel), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      (!_ctx.editable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(BaseCheckbox, {
                  modelValue: _unref(isSelected),
                  "onUpdate:modelValue": [
                    _cache[0] || (_cache[0] = ($event: any) => (_isRef(isSelected) ? (isSelected).value = $event : null)),
                    _cache[1] || (_cache[1] = (value) => _unref(handleSelectionChange)(value as boolean))
                  ],
                  name: _ctx.item.id,
                  border: false,
                  shadow: false,
                  label: ''
                }, null, 8, ["modelValue", "name"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_unref(PowerSelection), {
                  modelValue: isPowerMode.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isPowerMode).value = $event)),
                  "power-options": getSelectedPowerOptions(),
                  readonly: true,
                  "data-dusk": "power-selection"
                }, null, 8, ["modelValue", "power-options"])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_unref(PowerSelection), {
                modelValue: isPowerMode.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isPowerMode).value = $event)),
                "power-options": getAllPowerOptions(),
                class: "flex-1",
                "onUpdate:powerQuantities": _unref(handlePowerQuantitiesUpdate)
              }, null, 8, ["modelValue", "power-options", "onUpdate:powerQuantities"])
            ])
          ]))
    ]),
    _: 1
  }, 8, ["item", "category", "editable", "is-loading", "data-dusk", "fallback-image"]))
}
}

})